import { graphql } from 'gatsby';
import InfoTag from '@/components/InfoTag/InfoTag';

import { StyledContainer } from './InfoTagGroup.styles';

const InfoTagGroup = ({ elements }: Queries.INFO_TAG_GROUPFragment) => {
  const { tags } = elements;

  return (
    <StyledContainer>
      {tags.value.map((tag) => (
        <InfoTag key={tag.system.id} {...tag} />
      ))}
    </StyledContainer>
  );
};

export default InfoTagGroup;

export const fragment = graphql`
  fragment INFO_TAG_GROUP on kontent_item_info_tag_group {
    __typename
    system {
      codename
    }
    elements {
      tags {
        value {
          system {
            id
          }
          ...INFO_TAG
        }
      }
    }
  }
`;
